import { Check } from "flowbite-react-icons/outline";
import PropTypes from "prop-types";

LinkSetupStepIcon.propTypes = {
  currentStep: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
};

export default function LinkSetupStepIcon({ currentStep, step }) {
  return (
    <div
      className={`rounded-3xl text-xl p-2 ${currentStep > step ? "bg-success text-white" : "bg-base-100 border-neutral-400 border-2"} w-10 h-10 text-center flex justify-center items-center mr-3`}
    >
      {currentStep > step ? (
        <Check />
      ) : (
        <span className="font-bold w-full text-center h-full flex items-center justify-center">
          {step}
        </span>
      )}
    </div>
  );
}
